/* istanbul ignore file */
import _ from 'lodash'
import Cookies from 'js-cookie'
import logger from '@adc/logger'
import { mapNavigatorPositionToLocation } from './locationShare'

/**
 * Exported Actions
 */
export const GEO_LOCATION_COOKIE = 'geoLocation'
export const GEO_LOCATION_COOKIE_EXP = 1
export const COUNTRY_USA = 'US'

export const useIpGeoLocation = locationProvider => {
  const geoLocation = Cookies.get(GEO_LOCATION_COOKIE)
  if (geoLocation) {
    return new Promise(resolve => resolve(JSON.parse(geoLocation)))
  } else {
    return locationProvider()
      .then(res => {
        if (_.toUpper(res.two_letter_country) !== COUNTRY_USA) return {}
        const location = {
          city: _.startCase(res.city),
          state: _.toUpper(res.region),
          zipcode: res.postal_code,
          coordLongLat: `${res.latitude},${res.longitude}`,
        }
        // Create a cookie that expires 1 day from now, valid across the entire site
        Cookies.set(GEO_LOCATION_COOKIE, location, {
          expires: GEO_LOCATION_COOKIE_EXP,
        })
        return location
      })
      .catch(() => {
        return {}
      })
  }
}

export const useBrowserLocation = (success, failure) => {
  const handlers = { success, failure }
  const positionOptions = {
    timeout: 30000,
    maximumAge: 7200000,
  }
  window.navigator &&
    window.navigator.geolocation.getCurrentPosition(
      _.wrap(handlers, shareBrowserLocation),
      _.wrap(failure, denyBrowserLocation),
      positionOptions
    )
}

/**
 * Internal Actions
 */
const shareBrowserLocation = (handlers, position) => {
  mapNavigatorPositionToLocation(position)
    .then(res => {
      const coordLongLat =
        position.coords.latitude + ',' + position.coords.longitude
      const location = {
        city: _.startCase(res.search_city),
        state: _.toUpper(res.search_state),
        zipcode: res.zipcode,
        coordLongLat,
      }
      // Create a cookie that expires 1 day from now, valid across the entire site
      Cookies.set(GEO_LOCATION_COOKIE, location, {
        expires: GEO_LOCATION_COOKIE_EXP,
      })
      handlers.success(location)
      return res
    })
    .catch(err => {
      denyBrowserLocation(handlers.failure, err)
    })
}

const denyBrowserLocation = (failure, err) => {
  logger.debug('user did not share location', err)
  failure(err)
}
